export interface DemodeskPrefill {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface MeetingUrlType {
  hubspotUtk?: string | null;
  calendarSlug: string;
  meetingType: string;
  prefill?: DemodeskPrefill;
}

export const DEMODESK_BASE_URL = "https://demodesk.com";

const hubspotPrefillToDemodeskPrefillMap: Record<
  keyof DemodeskPrefill,
  string
> = {
  firstName: "customer_first_name",
  lastName: "customer_last_name",
  email: "customer_email",
  phone: "customer_phone",
};

const validMeetingTypesHiddenEmail = [
  "beratung-allgemein-selbstbucher-bucket-a",
  "beratung-allgemein-selbstbucher-bucket-b",
  "beratung-allgemein-selbstbucher-bucket-c",
] as const;

const validMeetingTypes = [
  ...validMeetingTypesHiddenEmail,
  "beratung-allgemein",
  "beratung",
  "angebotsbesprechung",
  "beratung-finanzcheck-medal-flow",
] as const;

type MeetingType = (typeof validMeetingTypes)[number];
type HiddenEmailMeetingType = (typeof validMeetingTypesHiddenEmail)[number];

const isValidMeetingType = (value: string): value is MeetingType => {
  return validMeetingTypes.includes(value as MeetingType);
};

const isHiddenEmailMeetingType = (
  value: string,
  prefill?: DemodeskPrefill,
): value is HiddenEmailMeetingType => {
  return (
    validMeetingTypesHiddenEmail.includes(value as HiddenEmailMeetingType) &&
    !!prefill?.email
  );
};

export const buildMeetingUrl = ({
  hubspotUtk,
  calendarSlug,
  meetingType,
  prefill,
}: MeetingUrlType) => {
  const _meetingType = isHiddenEmailMeetingType(meetingType, prefill)
    ? `${meetingType}-h`
    : isValidMeetingType(meetingType)
      ? meetingType
      : "beratung-allgemein";

  const url = new URL(
    `${DEMODESK_BASE_URL}/book/${calendarSlug}/${_meetingType}`,
  );
  if (hubspotUtk) {
    url.searchParams.append("hutk", hubspotUtk);
  }

  if (prefill) {
    for (const [key, value] of Object.entries(prefill)) {
      url.searchParams.append(hubspotPrefillToDemodeskPrefillMap[key], value);
    }
  }

  if (!url.searchParams.has("iframe")) {
    url.searchParams.append("iframe", "true");
  }

  return url.toString();
};
